
import EmptyState from '@/components/EmptyState.vue';
import { Component, Vue } from 'vue-property-decorator';
import { Route } from '@sentry/vue/types/router';
import { NavigationGuardNext } from 'vue-router';

@Component({
  components: {
    EmptyState,
  },
})
export default class OfferAcceptedConfirmation extends Vue {
  beforeRouteEnter(to: Route, from: Route, next: NavigationGuardNext): void {
    if (to.name === 'checkout_complete_with_discount' && from.path !== '/cancel-subscription')
      next({ path: '/my-account/billing' });
    next();
  }
}
